export default "__VITE_ASSET__CTlKbNYE__"